import { MagentoPersonalizedPriceProvider } from "@arcteryx/data-providers";
import Config from "../../common/config";

export const getPersonalizedPriceProvider = ({ market, country, language }) => {
  const apiUrl = Config.getMagentoUrl();
  // Hack to get the access token from the window object, which is put there by
  // the auth-adapter::AuthManager module in each consumer app.
  const getAccessToken = window.__NavGetAccessToken;
  return new MagentoPersonalizedPriceProvider({
    market,
    country,
    language,
    apiUrl,
    enableCaching: true,
    getAccessToken,
  });
};
